export const START = { x: 0, y: 0 };
export const GOAL = { x: 19, y: 19 };
export const DIMENSION = 20;
